import { useGlobalErrorContext } from 'shared/context/globalError.js';

export const useGlobalErrorHandlerEffects = () => {
  const { error, parsedError, clearError } = useGlobalErrorContext();

  if (error === null) {
    return {
      parsedError: null,
      open: false,
      onClose: clearError,
    };
  }

  return {
    open: error.error !== null,
    parsedError,
    onClose: clearError,
  };
};
